var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSocialTwitterBotton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-social-twitter-botton",
    transform: "translate(-320 -435)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BG-transp",
    width: 35,
    height: 35,
    transform: "translate(320 435)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M30.505,10.263c.022.3.022.6.022.906C30.527,20.381,23.515,31,10.7,31A19.692,19.692,0,0,1,0,27.867a14.416,14.416,0,0,0,1.683.086,13.955,13.955,0,0,0,8.651-2.977,6.981,6.981,0,0,1-6.515-4.833,8.788,8.788,0,0,0,1.316.108,7.37,7.37,0,0,0,1.834-.237,6.969,6.969,0,0,1-5.588-6.839v-.086a7.018,7.018,0,0,0,3.15.884,6.979,6.979,0,0,1-2.157-9.32,19.807,19.807,0,0,0,14.368,7.292,7.866,7.866,0,0,1-.173-1.6,6.975,6.975,0,0,1,12.06-4.768A13.719,13.719,0,0,0,33.051,3.9a6.95,6.95,0,0,1-3.063,3.84A13.969,13.969,0,0,0,34,6.66a14.979,14.979,0,0,1-3.495,3.6Z",
    transform: "translate(321 435.431)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialTwitterBotton);
export default __webpack_public_path__ + "static/media/Icon-social-twitter-botton.b41a2dca68477a1777048c4a4eb98930.svg";
export { ForwardRef as ReactComponent };